__turbopack_context__.v({
  "tooltip": "Tooltip-module-scss-module__O8odZa__tooltip",
  "tooltipContent": "Tooltip-module-scss-module__O8odZa__tooltipContent",
});
